import script from "./ContratoVendaAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./ContratoVendaAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./ContratoVendaAdministrar.vue?vue&type=style&index=0&id=fbe3120a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbe3120a"]])

export default __exports__